import { render, staticRenderFns } from "./Fjtest.vue?vue&type=template&id=d955d94c&scoped=true&"
import script from "./Fjtest.vue?vue&type=script&lang=js&"
export * from "./Fjtest.vue?vue&type=script&lang=js&"
import style0 from "./Fjtest.vue?vue&type=style&index=0&id=d955d94c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d955d94c",
  null
  
)

export default component.exports